import React from 'react'
import './Skeleton.sass'
import Skeleton from 'react-loading-skeleton'

const ThemedSkeleton = (props) => <Skeleton {...props} />
export default ThemedSkeleton
